export default __webpack_public_path__ + "static/media/Rocket.b24d9918.png";